import React from "react";

interface IResultLayoutProps {
  children: React.ReactNode;
  title: string;
  onTitleClick?: () => void;
}

const ResultLayout = (props: IResultLayoutProps) => {
  const { children, title, onTitleClick } = props;

  return (
    <div className="immersion__layout__result">
      <h2 className="immersion__layout__result__title" onClick={onTitleClick}>{title}</h2>
      <div className="immersion__layout__result__content">{children}</div>
    </div>
  );
};

export default ResultLayout;
